import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { PAGE_PATHS, Permission } from '../../../../../../../types';
import { defaultFilter as reportsDefaultFilter } from '../../../../../../../views/Reports/EditReports';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/targets/edit/$id/')({
  validateSearch: zodValidator(withDefaults(schema.REPORTS, defaultFilter, reportsDefaultFilter)),
  search: {
    middlewares: [stripSearchParams({ ...defaultFilter, ...reportsDefaultFilter })],
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.TARGETS }) ||
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.TARGETS, permission: Permission.UPDATE });
    context.validatePermissions({ isAllowed, preload });
  },
});
